export const RadialGradient = () => {
  return (
    <div
      style={{
        aspectRatio: 1,
        background: 'radial-gradient(50% 50% at 50% 50%, #00A4BF 0%, rgba(0, 164, 191, 0) 100%)',
      }}
      className=" absolute right-0 top-0 w-[200vw] max-w-[700px] -translate-y-1/2 translate-x-1/2 rounded-full bg-red opacity-[.18]"
    />
  )
}
